module.exports = __webpack_public_path__ + "img/challenge_campaign_header_frame.4db6a513.png";